<template>
    <footer v-if="isZentrolink" class="auth-footer" data-testid="auth-footer" aria-label="Zentrolink">
        <p v-if="testEnvironment" class="environment-notice" data-testid="test-environment-notice" role="status">
            {{ $t('authFooter.1') }}
        </p>
        <nav class="legal-links" :aria-label="$t('authFooter.2')">
            <a href="/legal/terms">{{ $t('authFooter.3') }}</a>
            <a href="/legal/privacy">{{ $t('authFooter.4') }}</a>
            <a href="/legal/datenschutz">{{ $t('authFooter.5') }}</a>
        </nav>
        <p class="ownership">© {{ currentYear }} Zentrolink UG (haftungsbeschränkt)</p>
    </footer>
</template>

<script>
export default {
    props: { testEnvironment: { type: Boolean, default: false } },
    data() { return { currentYear: new Date().getFullYear() }; },
    computed: {
        isZentrolink() {
            return this.$store.state.individual === 'Zentrolink';
        },
    },
};
</script>

<style lang="scss" scoped>
.auth-footer {
    width: 100%;
    margin-top: 28px;
    padding-top: 20px;
    border-top: 1px solid var(--line);
    color: var(--ink-faint);
    font-size: 12px;
    line-height: 1.45;
    text-align: center;
}

.environment-notice {
    margin: 0 0 12px;
    padding: 9px 12px;
    border-radius: 8px;
    background: var(--accent-surface);
    color: var(--ink);
    font-weight: 600;
}

.legal-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 6px 16px;
}

.legal-links a {
    color: var(--accent-link);
    text-decoration: none;
}

.legal-links a:hover,
.legal-links a:focus-visible { text-decoration: underline; outline: 2px solid currentColor; outline-offset: 3px; }

.ownership { margin: 8px 0 0; }

@media (max-width: 540px) {
    .auth-footer { margin-top: 22px; padding-top: 16px; }
}
</style>
